import axios from "axios";

import { handleRequestError } from "@/components/Utils/handleRequestError";
const path = "/api/v1/products/";

// хелпер
const normalizeTags = (tags) => {
  if (Array.isArray(tags) && tags.length) {
    return tags.map((tag) => tag.text ?? tag).join(",");
  }
  if (typeof tags === "string") {
    return tags;
  }
  return "";
};
const getCollectionsString = (collections) => {
  return collections
    .filter((item) => item.count > 0)
    .map((item) => item.key)
    .sort();
};

/**
 *
 * @param {Number} limit
 * @param {Number} offset
 * @param {Array} collections - массив из ключей коллекций
 * @param {String} search
 * @param {Boolean} cancelPrev - можно ли отменить запрос если функция вызвана повторно
 * @returns продукты фильтрованные по пагинации, поиску, коллекциям
 */

let prevControllerGET_PRODUCTS = null; // идентификатор по которому можно отменить прошлый запрос
const defaultOptions = {
  limit: 30,
  offset: 0,
  collections: [],
  search: "",
  tags: "", // string | array
  excludeTags: "", // string | array
  tagsMode: "all", // "all" | "any"
  nextUrl: "",
  cancelPrev: true,
};

export async function GET_PRODUCTS(inputOptions) {
  const options = { ...defaultOptions, ...inputOptions };
  let url;

  if (options.nextUrl) {
    // При пагинации используем готовый URL целиком
    url = options.nextUrl;
  } else {
    url = path + `?limit=${options.limit}`;
    url += `&offset=${options.offset}`;

    if (options.search) {
      url += `&search=${options.search}`;
    }

    if (options.collections?.length) {
      url += `&collections=${getCollectionsString(options.collections)}`;
    }

    const tags = normalizeTags(options.tags);
    if (tags) {
      url += `&tags=${encodeURIComponent(tags)}`;
    }

    const excludeTags = normalizeTags(options.excludeTags);

    if (excludeTags) {
      url += `&exclude_tags=${encodeURIComponent(excludeTags)}`;
    }

    if (tags || excludeTags) {
      url += `&tags_mode=${options.tagsMode}`;
    }
  }

  if (options.cancelPrev && prevControllerGET_PRODUCTS) {
    // если запрос можно отменить и прошлый идентификатор отмены заполнен
    prevControllerGET_PRODUCTS.abort("Отменено мной ибо не нужно");
  }
  prevControllerGET_PRODUCTS = new AbortController(); // заполняем идентификатор запросы для возможности отменить его
  try {
    const resp = await axios.get(url, {
      signal: prevControllerGET_PRODUCTS.signal,
    });
    return resp.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      return { results: [], count: null, total_count: 999, isCanceled: true }; // при отмене возвращаем обычные данные, чтобы ничего не упало
    }
    if (error) {
      handleRequestError(error);
    }
  }
}

/**
 *
 * @param {Number} folderId - id папки
 * получает id папки, возвращает продукты связанные с этой папкой
 */
let prevControllerBY_FOLDER = null; // идентификатор по которому можно отменить прошлый запрос
// доделать пагинацию
export async function GET_PRODUCTS_BY_FOLDER_ID(folderId, inputOptions = {}) {
  const options = {
    ...defaultOptions,
    ...inputOptions,
    library: folderId, // Добавляем параметр library
  };

  let url =
    options.nextUrl || `${path}?library=${options.library}&limit=${options.limit}&offset=${options.offset}`;

  if (prevControllerBY_FOLDER) {
    prevControllerBY_FOLDER.abort("Отменено мной ибо не нужно");
  }
  prevControllerBY_FOLDER = new AbortController();

  try {
    const resp = await axios.get(url, {
      signal: prevControllerBY_FOLDER.signal,
    });
    return resp.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      return { results: [], next: null }; // Стандартный ответ при отмене
    }
    handleRequestError(error);
    throw error; // Передаем ошибку дальше
  }
}

export async function CLONE_PRODUCT(productId, inputOptions) {
  try {
    const resp = await axios.post(`${path}${productId}/clone/`, inputOptions);

    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function ACTIVATE_PRODUCT(inputOptions) {
  try {
    const resp = await axios.post(`${path}activation/`, inputOptions);

    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function DELETE_PRODUCT(productId) {
  try {
    await axios.delete(`${path}${productId}/`);

    // return resp.data;
    return true;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function UPDATE_PRODUCT(productId, inputOptions) {
  try {
    const resp = await axios.patch(`${path}${productId}/`, inputOptions);

    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function CREATE_PRODUCT(inputOptions) {
  try {
    const resp = await axios.post(`${path}`, inputOptions);

    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function GET_PRODUCT(productId) {
  try {
    const resp = await axios.get(`${path}${productId}/`);

    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export {
  BULK_COPY_BRANDING,
  BULK_UPDATE_ALL_WIDGETS,
  BULK_UPDATE_WIDGETS,
} from "@/components/Widget/servise/api";
